import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import Cookies from 'universal-cookie'
import { decodeText, encodedText } from '../plugins/encrypt'
import { refreshToken } from '../services/auth'
import http from '../plugins/axios'

const cookies = new Cookies()

const generateToken = (session) => {
  let token = ''
  if (session) {
    const decode = decodeText(session)
    token = JSON.parse(decode)
  }
  return token
}

export const getCredential = createAsyncThunk('auth/getCredential', async () => {
  const session = cookies.get('token')
  let responseCredential = ''
  if (session !== undefined) {
    const sessionLogin = generateToken(session)
    const payload = {
      refresh_token: sessionLogin.refresh_token
    }
    const response = await refreshToken(payload)
    responseCredential = response
  } else {
    responseCredential = 'no token available'
  }
  return responseCredential
})

const authData = createSlice({
  name: 'auth',
  initialState: {
    isLoading: true,
    dataUser: null,
    isLogin: false
  },
  reducers: {
    update: (state, action) => {
      state.dataUser = action.payload.dataUser
      state.isLogin = action.payload.isLogin
      state.isLoading = action.payload.isLoading
    }
  },
  extraReducers: {
    [getCredential.pending]: (state) => {
      state.isLoading = true
    },
    [getCredential.fulfilled]: (state, action) => {
      if (action.payload !== 'no token available') {
        http.defaults.headers.common['Authorization'] = `Bearer ${action.payload.access_token}`
        const stringValue = JSON.stringify(action.payload)
        const encodedData = encodedText(stringValue)
        cookies.set('token', encodedData, { path: '/' })        
        state.isLogin = true
        state.dataUser = action.payload
        state.isLoading = false
      } else {
        state.isLogin = false
        state.dataUser = action.payload
        state.isLoading = false
      }
      
    },
    [getCredential.rejected]: (state) => {
      state.isLoading = false
      state.isLogin = false
      state.dataUser = null
    }
  }
})

export const { update } = authData.actions
export default authData.reducer